// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5fe5bbb4","453":"c02520e2","796":"6e674708"}[chunkId] + ".chunk.js";
};